/**
 * Shared locale / i18n utilities used across all apps.
 */

/**
 * Map internal language codes to circle-flags icon codes.
 *
 * Most codes match 1:1 (e.g. `en` → `en`), but some differ:
 * - `ee` (Estonian locale code) → `et` (circle-flags code)
 * - `ua` (Ukrainian locale code) → `uk` (circle-flags code)
 */
export function langToFlagCode(langCode: string): string {
  const code = langCode.split('-')[0] ?? '';
  const flagMap: Record<string, string> = {
    ee: 'et', // Estonian
    ua: 'uk', // Ukrainian
  };
  return flagMap[code] || code;
}
